
import { Vue, Component } from "vue-property-decorator";

import { DropDownItem } from '@share/common/drop-down/types';
import { Modal } from '@common/Modal';
import { MenuEvent } from "@api/enums/MenuEvents";

@Component({})

export default class Deletable extends Vue {
    get menuItems(): DropDownItem[] {
        return [
            {
                title: this.$t('common.delete').toString(),
                id: MenuEvent.delete
            }
        ];
    }

    async delete(title: string) {
        const confirmed = await this.doConfirm(title);

        if(confirmed && confirmed !== "close") {
            this.$emit(MenuEvent.delete);
        }
    }

    async doConfirm(title: string) {
        const modal = new Modal({
            title,
            buttons: [
                {
                    text: this.$t('common.yes').toString(),
                    class: 'is-green is-middle',
                    returnValue: true
                },
                {
                    text: this.$t('common.no').toString(),
                    class: 'is-red is-middle',
                    returnValue: false
                },
            ]
        });

        return await modal.showConfirm()
    }
}

